import { takeLatest, put, call } from 'redux-saga/effects';

import { listContaBancoCadastro } from '../service';
import {
  TABLE_CONTA_BANCO_CADASTRO,
  TABLE_CONTA_BANCO_CADASTRO_PENDING,
  TABLE_CONTA_BANCO_CADASTRO_SUCCESS,
  TABLE_CONTA_BANCO_CADASTRO_FAILURE
} from '../actionTypes';

function* sagaListContaBancoCadastro(action) {
  yield put({ type: TABLE_CONTA_BANCO_CADASTRO_PENDING })

  try {
    const table = yield call(listContaBancoCadastro, action.args)
    yield put({ type: TABLE_CONTA_BANCO_CADASTRO_SUCCESS, table: table })

  } catch (error) {

    yield put({ type: TABLE_CONTA_BANCO_CADASTRO_FAILURE })
    // console.error(error) // eslint-disable-line

  }
}

export default function* watchListContaBancoCadastro() {
  yield takeLatest(TABLE_CONTA_BANCO_CADASTRO, sagaListContaBancoCadastro)
}